import { Grid } from "@mui/material";
import { ShowBase, useResourceContext } from "ra-core";
import { FC } from "react";
import PullImageCard from "@/components/settings/secureai/PullImageCard";




const SecureAIAppSetting: FC = () => {
  const resource = useResourceContext()

  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <ShowBase resource={resource} id="info" basePath="">
          <PullImageCard productName="SecureAI App" imageName="ondata-secureai-app"/>
        </ShowBase>
      </Grid>

    </Grid>
  )
}

export default SecureAIAppSetting;

